import React from 'react';
import InteractionEnumIcon from '@/components/common/InteractionEnumIcon';
import InteractionType from '@/constants/InteractionType';
import translate from '@/lib/intl/translate';
import { EmailParticipants } from '@/modules/Comms';
import EntityDate from './EntityDate';

const CLASSES = {
  interaction: {
    icon: 'inline',
  },
};

type EmailIntegrationReceivedSummaryProps = {
  entity: unknown | unknown;
};

export default function EmailIntegrationReceivedSummary({
  entity,
}: EmailIntegrationReceivedSummaryProps) {
  const {
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'bccRecipients' does not exist on type 'u... Remove this comment to see the full error message
    bccRecipients = [],
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'ccRecipients' does not exist on type 'un... Remove this comment to see the full error message
    ccRecipients,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'commsId' does not exist on type 'unknown... Remove this comment to see the full error message
    commsId,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'messageDatetime' does not exist on type ... Remove this comment to see the full error message
    messageDatetime,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'toRecipients' does not exist on type 'un... Remove this comment to see the full error message
    toRecipients = [],
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'sender' does not exist on type 'unknown'... Remove this comment to see the full error message
    sender,
  } = entity;
  const recipients = React.useMemo(
    () => [...toRecipients, ...(ccRecipients || [])],
    [ccRecipients, toRecipients],
  );

  const isBccOnly = bccRecipients.length && !toRecipients.length;

  const interactionIcon = (
    <InteractionEnumIcon
      classes={CLASSES.interaction}
      enumValue={InteractionType.EMAIL}
      iconOnly
      type={InteractionEnumIcon.interactionType}
    />
  );
  return (
    <span className="font-normal">
      {isBccOnly
        ? translate('EMAIL_INTEGRATION_RECEIVED_BCC_ONLY_SUMMARY', {
            bccRecipients: (
              <EmailParticipants participants={bccRecipients} showAll />
            ),
            date: (
              <EntityDate entityId={commsId} dateString={messageDatetime} />
            ),
            interactionIcon,
            sender: <EmailParticipants participants={sender} showAll />,
          })
        : translate('EMAIL_INTEGRATION_RECEIVED_SUMMARY', {
            recipients: <EmailParticipants participants={recipients} showAll />,
            interactionIcon,
            date: (
              <EntityDate entityId={commsId} dateString={messageDatetime} />
            ),
            sender: <EmailParticipants participants={sender} showAll />,
          })}
    </span>
  );
}
